import {
    invalidAvailability,
    invalidAvailabilityBorder,
    validAvailability,
    validAvailabilityBorder,
} from "@/styles/colors";
import { sharedStyles } from "@/styles/shared";
import { CURRENT_SUBDOMAIN, DEMANDORIA_SUBDOMAINS } from "@/utils/stringUtils";
import { Box, SxProps, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const WorkingScaleCaption = () => {
const { t } = useTranslation();
const isDemandoria = CURRENT_SUBDOMAIN === DEMANDORIA_SUBDOMAINS[2];

return (
    <Box sx={{ ...sharedStyles.horizontalContent, gap: 3 }}>
    <Box sx={sharedStyles.horizontalContent}>
        <Box
        sx={{
            ...styles.captionRectangle,
            backgroundColor: validAvailability,
            border: `1px solid ${validAvailabilityBorder}`,
        }}
        />
        <Typography>
        {isDemandoria
            ? t("workingScale.caption.open")
            : t("workingScale.caption.available")}
        </Typography>
    </Box>

    <Box sx={sharedStyles.horizontalContent}>
        <Box
        sx={{
            ...styles.captionRectangle,
            backgroundColor: invalidAvailability,
            border: `1px solid ${invalidAvailabilityBorder}`,
        }}
        />
        <Typography>
        {" "}
        {isDemandoria
            ? t("workingScale.caption.closed")
            : t("workingScale.caption.occupied")}
        </Typography>
    </Box>
    </Box>
);
};

export default WorkingScaleCaption;

const styles = {
captionRectangle: {
    width: "30px",
    height: "20px",
} as SxProps,
};